import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store'

import './plugins/load'


import '@/styles/main.scss'

Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.silent = process.env.NODE_ENV !== 'production';
Vue.config.productionTip = process.env.NODE_ENV !== 'production'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
